import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { RESET } from 'action-creators/generic';
import {
  TRAVELS_ADMIN_REQUEST,
  FETCH_ALL_TRAVELS_ADMIN_SUCCESSFUL,
  FETCH_ALL_TRAVELS_ADMIN_FAILURE,
  SET_TRAVEL_ITINERARY_ID,
} from 'action-creators/travel';
import { TravelsApprovalResponse } from 'models/travelApproved';

export interface TravelState {
  isLoading: boolean;
  travelApprovalResult: TravelsApprovalResponse | null;
  error: boolean | null;
  travelItineraryId?: string;
}

const initialState: TravelState = {
  isLoading: false,
  travelApprovalResult: null,
  error: null,
};

const reducer: Reducer<TravelState> = (state = initialState, action) => {
  switch (action.type) {
    case TRAVELS_ADMIN_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_ALL_TRAVELS_ADMIN_SUCCESSFUL:
      return {
        ...state,
        travelApprovalResult: action.payload.data,
        isLoading: false,
      };
    case FETCH_ALL_TRAVELS_ADMIN_FAILURE:
      return {
        ...state,
        travelApprovalResult: null,
        error: action.payload,
        isLoading: false,
      };
    case SET_TRAVEL_ITINERARY_ID:
      return {
        ...state,
        travelItineraryId: action.payload,
    }
    case RESET:
      return initialState;
    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'travel',
  blacklist: ['isLoading', 'error'],
};

export default persistReducer(persistConfig, reducer);
